module.exports = __webpack_public_path__ + "img/summary_md.e1d4c6b1.png";